'use client';

const MainErrorKG = () => (
  <div className="min-h-[calc(100vh-302px)] flex items-center max-md:py-10 md:py-20">
    <div className="container px-4 w-full flex flex-col items-center text-center">
      <p className="text-sm font-bold text-kg-mako tracking-wider">
        <span aria-hidden="true">{'>'}</span> ERROR
      </p>
      <h1 className="mt-5 max-md:text-3xl md:text-4xl font-bold text-kg-black-pearl tracking-tighter">
        Error 500
      </h1>
      <p className="text-kg-black-pearl mt-5 font-bold text-lg">Down for Maintenance</p>
      <p className="text-kg-mako mt-3">
        We&apos;re upgrading our site to serve you better. Thanks for your understanding!
      </p>
      <button
        className="mt-7 w-fit text-sm text-white font-medium px-6 py-3 rounded-sm bg-kg-fun-blue hover:bg-kg-deep-sapphire default-transition"
        onClick={() => window.location.reload()}
      >
        TRY AGAIN
      </button>
    </div>
  </div>
);

export default MainErrorKG;
